/**
 * SecureEmbed Energy Portal - DataSourceBadge Component
 */

import React from 'react';
import { DATASOURCE_COLORS } from '../constants/colors';

interface DataSourceBadgeProps {
  source: string;
  size?: 'sm' | 'md';
}

const DataSourceBadge: React.FC<DataSourceBadgeProps> = ({ source, size = 'sm' }) => {
  const key = source.toLowerCase().replace(/[-_\s]/g, '');
  const ds = DATASOURCE_COLORS[key] || DATASOURCE_COLORS[source] || DATASOURCE_COLORS.custom;

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${ds.bg} ${ds.text} ${sizeClasses}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: ds.hex }} />
      {ds.label}
    </span>
  );
};

export default DataSourceBadge;
